import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {

                },
                url: {
                    getMenu: `${codeAPI}/front/sidebar/menu`,
                    getPage: `${codeAPI}/front/sidebar/page/:slug`,
                },
                menu: {
                    loaded: false,
                    items: []
                },
                page: {
                    title: null,
                    content: null,
                    slug: null,
                    locale: null,
                    label: null,
                    icon: null,
                    default: null,
                    order: null,
                }
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'Backoffice',
                label: 'Backoffice',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'IG_00006',
                },
                url: {
                    view: `{moduleCode}gestao.home`
                }
            },
        },
        config: {

        },
    },
};

export default state;